import { useMemo } from 'react';
import { MenuItem } from '../types';
import useRoutes from '../../../routes/routes';
import { useUserData } from '../../../context/UserDataContext';

export const useMenuStructure = (): MenuItem[] => {
    const routes = useRoutes();
    const { personData } = useUserData();

    const menuStructure = useMemo(() => {
        const offers = personData?.OffersResponse?.GetOffersResponses || [];
        const now = new Date();
        const availableOffersCount = offers.filter(offer => {
            if (offer.used) return false;
            if (offer.endDate && new Date(offer.endDate) < now) return false;
            if (offer.startDate && new Date(offer.startDate) > now) return false;
            return true;
        }).length;

        const menu: MenuItem[] = routes.map(route => ({
            id: route.path || route.name.toLowerCase().replace(/\s+/g, '-'),
            label: route.name,
            icon: route.icon || 'bx bx-circle',
            path: route.path,
            badge: route.path === '/mes-offres' && availableOffersCount > 0 ? availableOffersCount : undefined,
            subMenu: route.children?.map(child => ({
                id: child.path || child.name.toLowerCase().replace(/\s+/g, '-'),
                label: child.name,
                path: child.path,
            }))
        }));

        return menu;
    }, [routes, personData]);

    return menuStructure;
};

